'use client';

import { c as _c } from "react/compiler-runtime";
import type { SyntheticEvent } from 'react';
import { useCallback, useEffect, useRef } from 'react';
import { AppImage } from '@/app/components/media/app-image';
import { SPARTAN_PRODUCT_ENGINE_LOGO, SPARTAN_PRODUCT_ENGINE_LOGO_MOBILE_SIZES } from '@/app/lcv/components/sections/spartan/products/engine/constants';
import { SpartanProductEngineStageMedia } from '@/app/lcv/components/sections/spartan/products/engine/stage/media';
import { getEngineLogoMobileSrc, getEnginePreloadAssetCount } from '@/app/lcv/components/sections/spartan/products/engine/utils';
import type { SpartanProductEngineMediaPreloaderItemProps } from '@/app/lcv/components/sections/spartan/products/engine/view/media-preloader/item/types';
export const SpartanProductEngineMediaPreloaderItem = t0 => {
  const $ = _c(31);
  const {
    engine,
    index,
    lowPriority,
    onReady
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new WeakSet();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const settledElementsRef = useRef(t1);
  const settledCountRef = useRef(0);
  const didNotifyRef = useRef(false);
  const assetCount = getEnginePreloadAssetCount(engine);
  const fetchPriority = lowPriority ? "low" : undefined;
  let t2;
  if ($[1] !== engine.logo) {
    t2 = getEngineLogoMobileSrc(engine.logo);
    $[1] = engine.logo;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const mobileLogoSrc = t2;
  const desktopLogoSrc = engine.logo.src;
  const hasDistinctMobileLogo = mobileLogoSrc !== desktopLogoSrc;
  const {
    mobile: mobileLogoSize,
    desktop: desktopLogoSize
  } = SPARTAN_PRODUCT_ENGINE_LOGO;
  let t3;
  if ($[3] !== index || $[4] !== onReady) {
    t3 = () => {
      if (didNotifyRef.current) {
        return;
      }
      didNotifyRef.current = true;
      onReady(index);
    };
    $[3] = index;
    $[4] = onReady;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const notifyReady = t3;
  let t4;
  if ($[6] !== assetCount || $[7] !== notifyReady) {
    t4 = event => {
      if (settledElementsRef.current.has(event.currentTarget)) {
        return;
      }
      settledElementsRef.current.add(event.currentTarget);
      settledCountRef.current = settledCountRef.current + 1;
      if (settledCountRef.current >= assetCount) {
        notifyReady();
      }
    };
    $[6] = assetCount;
    $[7] = notifyReady;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleSettled = t4;
  let t5;
  let t6;
  if ($[9] !== assetCount || $[10] !== notifyReady) {
    t5 = () => {
      if (assetCount === 0) {
        notifyReady();
      }
    };
    t6 = [assetCount, notifyReady];
    $[9] = assetCount;
    $[10] = notifyReady;
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  useEffect(t5, t6);
  let t7;
  if ($[13] !== desktopLogoSrc || $[14] !== fetchPriority || $[15] !== handleSettled) {
    t7 = <AppImage src={desktopLogoSrc} alt="" width={desktopLogoSize.width} height={desktopLogoSize.height} sizes={`${desktopLogoSize.width}px`} fade={false} loading="eager" fetchPriority={fetchPriority} customRatio={true} onLoad={handleSettled} />;
    $[13] = desktopLogoSrc;
    $[14] = fetchPriority;
    $[15] = handleSettled;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== fetchPriority || $[18] !== handleSettled || $[19] !== hasDistinctMobileLogo || $[20] !== mobileLogoSrc) {
    t8 = hasDistinctMobileLogo ? <AppImage src={mobileLogoSrc} alt="" width={mobileLogoSize.width} height={mobileLogoSize.height} sizes={SPARTAN_PRODUCT_ENGINE_LOGO_MOBILE_SIZES} fade={false} loading="eager" fetchPriority={fetchPriority} customRatio={true} onLoad={handleSettled} /> : null;
    $[17] = fetchPriority;
    $[18] = handleSettled;
    $[19] = hasDistinctMobileLogo;
    $[20] = mobileLogoSrc;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== engine.stageMedia || $[23] !== fetchPriority || $[24] !== handleSettled || $[25] !== index) {
    t9 = !!engine.stageMedia && <SpartanProductEngineStageMedia media={engine.stageMedia} index={index} loading="eager" fetchPriority={fetchPriority} preloadOnly={true} onLoad={handleSettled} />;
    $[22] = engine.stageMedia;
    $[23] = fetchPriority;
    $[24] = handleSettled;
    $[25] = index;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
    t10 = <div hidden={true} aria-hidden={true}>{t7}{t8}{t9}</div>;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
};